var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{ref:"descargarApp",staticClass:"btn ripple btn-block text-white text-icon",staticStyle:{"background-color":"#bfa826"},on:{"click":_vm.ExportFile}},[_vm._v("Descargar APK "),_c('i',{staticClass:"fab fa-android"})])])}
var staticRenderFns = []

export { render, staticRenderFns }